module.exports = __webpack_public_path__ + "img/icon.aa627f29.png";